import { GlobalAppState } from '@model/state';

export const getTourReferences = (state: GlobalAppState) => state.tours.tourReferences.packageReferences;
export const getTourReferencesError = (state: GlobalAppState) => state.tours.tourReferences.error;
export const getFromTourReference = (state: GlobalAppState) => state.tours.tourReferences.fromTourReference;
export const getLeadInTourReferences = (state: GlobalAppState) => state.tours.tourReferences.leadInTourReferences;
export const getTourReferencesLoading = (state: GlobalAppState) => state.tours.tourReferences.isLoading;
export const getFromTourReferenceLoading = (state: GlobalAppState) =>
  state.tours.tourReferences.isFromTourReferenceLoading;
